import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  Icons,
} from '@commenda/kakashi';
import { FilingCalendarPreviewData } from '../../types';

interface CalendarGenerationConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  previewData: FilingCalendarPreviewData | undefined;
  isGenerating: boolean;
}

export function CalendarGenerationConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  previewData,
  isGenerating,
}: CalendarGenerationConfirmationModalProps) {
  if (!previewData) return null;

  const newFilingsCount = previewData?.proposed_filings?.length ?? 0;

  const totalGapMonths = previewData?.coverage_gaps?.length ?? 0;
  const deletedFilingCounts = previewData?.filings_to_delete?.length ?? 0;

  const hasGaps = previewData.has_coverage_gaps && totalGapMonths > 0;
  const hasDeletedFilings = deletedFilingCounts > 0;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="p-0 flex flex-col gap-4 min-w-[500px]">
        <div className="p-6 pb-0">
          <div className="w-12 h-12 rounded-md bg-utility-warning-50 flex justify-center items-center">
            <Icons.AlertCircle className="size-6 text-utility-warning-600" />
          </div>
        </div>
        <div className="px-6">
          <h3 className="txt-lg-bold text-text-primary mb-2">
            Confirm Calendar Generation
          </h3>
          <div className="txt-small-regular text-text-primary space-y-2">
            <p>
              This action will create <strong>{newFilingsCount}</strong>{' '}
              {newFilingsCount === 1 ? 'new filing' : 'new filings'} for the
              selected tax period.
            </p>

            {hasGaps && (
              <p className="text-text-error">
                <strong>Note:</strong> <strong>{totalGapMonths}</strong>{' '}
                {totalGapMonths === 1 ? 'tax period is' : 'tax periods are'} not
                covered by any filing.
              </p>
            )}

            {hasDeletedFilings && (
              <p className="text-text-error">
                <strong>Note:</strong> <strong>{deletedFilingCounts}</strong>{' '}
                {deletedFilingCounts === 1 ? 'filing entry' : 'filing entries'}{' '}
                will be deleted.
              </p>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button size="sm" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button size="sm" onClick={onConfirm} disabled={isGenerating}>
            {isGenerating ? 'Confirming...' : 'Confirm'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
